import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';
import { UserService } from '../../services/user.service';
import { IUser } from "../../interfaces/user";
import { Permission } from '../../interfaces/permission.enum';
import { IBranding } from '../../interfaces/branding';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: [''],
    standalone: false
})
export class HeaderComponent implements OnInit {
  public isNavbarCollapsed: boolean = true;
  public isLoggedIn: boolean = false;
  public displayName: string;
  public showSecAdminLink: boolean;
  public secAdminLink: string;
  public errorMessage: string;
  public branding: IBranding;

  public constructor(
    private readonly configService: ConfigurationService,
    private readonly userService: UserService,
    private readonly errorService: ErrorService) { }

  public ngOnInit(): void {
    var currentUser = this.userService.getCurrentUser();
    this.UpdateUserValues(currentUser);

    this.userService.CurrentUser
      .subscribe(currentUser => {
        this.UpdateUserValues(currentUser);
      }, error => {
          this.errorMessage = this.errorService.getErrorMessage(error);
      });

    this.configService.getBranding()
      .subscribe(
        data => this.branding = data,
        error => this.errorMessage = this.errorService.getErrorMessage(error)
      );
  }

  public toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  private UpdateUserValues(currentUser: IUser) {
    if (currentUser) {
      this.isLoggedIn = true;
      this.displayName = currentUser.displayName;
      this.showSecAdminLink = currentUser.permissions.includes(Permission.ShowSecAdminLink);
      this.configService.getSecAdminLink()
        .subscribe(data => {
          this.secAdminLink = data;
        }, error => {
          this.errorMessage = this.errorService.getErrorMessage(error);
        });
    } else {
      this.isLoggedIn = false;
    }
  }
}
